import { Controller } from "stimulus";

export default class extends Controller {
  get grid_items() {
    return document.querySelector(".grid__item");
  }

  get grid_details_toggle() {
    return document.querySelector(".grid__item--details");
  }

  connect() {
    console.log("template_hidden_special_offer connected");
  }
}
